import React from 'react';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const FontBoldIcon = React.memo(function FontBoldIcon(props: TFontBoldIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Bold" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.6001 10V6H11.6001C12.7047 6 13.6001 6.89543 13.6001 8C13.6001 9.10457 12.7047 10 11.6001 10H7.6001ZM6.1001 10V4.90299C6.1001 4.68042 6.28052 4.5 6.50308 4.5H11.6001C13.5331 4.5 15.1001 6.067 15.1001 8C15.1001 8.95969 14.7138 9.82917 14.0883 10.4615C15.141 11.0649 15.8501 12.1996 15.8501 13.5C15.8501 15.433 14.2831 17 12.3501 17H6.53667C6.29556 17 6.1001 16.8045 6.1001 16.5634V11.5V10ZM11.6001 11.5H7.6001V15.5H12.3501C13.4547 15.5 14.3501 14.6046 14.3501 13.5C14.3501 12.3954 13.4547 11.5 12.3501 11.5H11.6001Z"
            />
        </IconBase>
    );
});

export default FontBoldIcon;

// #region Types

export type TFontBoldIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <FontBoldIcon /> : { ...IconBaseExample, render: FontBoldIcon };

// #endregion
